import Navbar from '../../components/Navbar/Navbar';
import * as Styled from './LegalStyles';
import HeaderImage from '../../../images/charco-message.svg';
import FooterNav from '../../components/FooterNav/FooterNav';
import Meta from '../../components/Meta/Meta';


const SecurityPractices = () => {
  const navLinks = [{
    title: 'Privacy Policy',
    link: '/privacy'
  }, {
    title: 'Terms of Service',
    link: '/tos'
  }, {
    title: 'Security Practices',
    link: '/security'
  }]

  return (
    <section>
      <Meta page="security" />
      <Navbar
        title="Privacy & Terms"
        links={navLinks}
      />
      <Styled.PageWrapper>
        <Styled.H1 id="top">
          Security Practices at Trova
        </Styled.H1>
        <Styled.Heading>
          <Styled.Img src={HeaderImage} alt="terms of service" />
          <Styled.H4>
            Data protection comes first
          </Styled.H4>
          <Styled.Subtitle className="text-left">
            We take your data security as our priority at Trova. We aim to be transparent and open about handling data security to build mutual trust with our users. If you have additional security questions, we are happy to answer them at <a href="mailto:info@gotrova.ai">info@gotrova.ai</a>.
          </Styled.Subtitle>
        </Styled.Heading>
        <Styled.H4 id="agreement">
          Minimal personal information stored
        </Styled.H4>
        <Styled.Paragraph>
          Trova does not store your passwords from any connected accounts . All logins to the connected accounts are performed using  OAuth verification. Moreover, Trova does not store your actual messages or files. With your permission, Trova’s search engine will create a rich index of your messages, documents, and chats. This encrypted index is used by our AI algorithms to find your search results. Once we process your content, we delete it from our servers, keeping only the rich index. When you make a query, we use our index to find exactly what you need quickly. We periodically check your accounts for any new messages to ensure that our indexes are up-to-date.
        </Styled.Paragraph>
        <Styled.H4>
          Data Encryption
        </Styled.H4>
        <Styled.Paragraph>
          All user information is stored on military-grade encrypted servers (AES 256). Trova, by default, encrypts data at rest and data in transit for all our users.
        </Styled.Paragraph>
        <Styled.H4>
          Users are in control
        </Styled.H4>
        <Styled.Paragraph>
          Users can disconnect an account or delete a Trova account at any time, and any data associated with the account(s) will be removed from our servers. Users can also easily reconnect accounts or re-sign up with Trova. <br />
          No other third parties can access your data. Trova never sells and never will sell users’ data. We are GDPR and CCPA compliant. The company is also in the process of passing SOC2 certification.
        </Styled.Paragraph>
        <Styled.H4>
          24/7 monitoring & External security audit
        </Styled.H4>
        <Styled.Paragraph>
          Trova monitors data security for our users 24/7/365. We contract with respected external companies to  perform regular security audits of Trova and to monitor new vulnerabilities.
        </Styled.Paragraph>
        <Styled.H4>
          Confidentiality
        </Styled.H4>
        <Styled.Paragraph>
          We place strict controls over our employees’ access to the data users made available to Trova. There might be times that require some employees to access the systems that store and process Customer Data. For example, when diagnosing a problem you encounter with the Trova services, we may need to access your Data. These employees are prohibited from using these permissions to view your Data unless it is necessary to do so. All the employees and contractors receive regular privacy and security training.
        </Styled.Paragraph>

      </Styled.PageWrapper>
      <FooterNav />
    </section>
  )
}

export default SecurityPractices